import React from 'react'
import { VideoHelper } from './imports'
import { videoStates } from './spotStateConstants'
const dogSleeping = require('../../../assets/studentPreChecks/DogSleeping.mp4')
const dogAwake = require('../../../assets/studentPreChecks/DogAwake.mp4')

export default function Spot(props){

    const { spotState } = props

    const isInvisible = spotState === videoStates.invisible
    const isSleeping = spotState === videoStates.sleeping
    const isAwake = spotState === videoStates.awake || spotState === videoStates.wokeUpFromSleep

    if( isInvisible ){
        return null
    }

    if( isSleeping ){
        return <VideoHelper videoSrc={dogSleeping} loop={true}/>
    }
    
    if( isAwake ){
        return <VideoHelper videoSrc={dogAwake} loop={true}/>
    }

    // default to sleep
    return <VideoHelper videoSrc={dogSleeping} loop={true}/>
}